import { useState, useEffect } from 'react';
import { DEFAULT_VALUES } from '../constants';

export const useDebounce = (value, delay = DEFAULT_VALUES.DEBOUNCE_DELAY) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
};

export default useDebounce;